import React, { Component } from 'react';
import './css/popupstyle.css';
import Search_Icon from '../../src/components/css/dark/img/theme-images/search.svg'
import $ from 'jquery/dist/jquery.min.js';
import { userService } from '../_services';

const SCROLL_SECTION_LOADING = {
    CITY: false,
    ZIP: false,
    DRUG: false,
    PHARMACYNAME: false,
    PRESCRIBERNAME: false,
    GROUPNUMBER: false,
    DISTRIBUTOR: false,
    WHOLESALER: false
};

class EditFilter extends React.Component {

    constructor(props) {
        super(props);
        var _roletype = '', _rolename = '';
        try {
            var userdata = JSON.parse(localStorage.getItem('user'));
            if (userdata.userrole == "Distributor" && userdata.wholesaler == "Avenel") {
                _roletype = "distributor";
                _rolename = userdata.paramsname;
            }
            else if (userdata.userrole == "Distributor" && userdata.wholesaler != "Avenel") {
                _roletype = "distributor";
                _rolename = userdata.paramsname;
            }
            else {
                _roletype = userdata.userrole;
                _rolename = userdata.paramsname;
            }
        }
        catch (error) { }
        this.state = {
            wname: this.props.wholesaler_name,
            userdata: JSON.parse(localStorage.getItem('user')),
            CityJson: [],
            StateJson: [],
            ZipJson: [],
            DrugJson: [],
            PharmacyJson: [],
            PrescriberJson: [],
            GroupNameJson: [],
            DistributorJson: [],
            WholesalerJson: [],
            PbmJson: [],
            BinJson: [],
            GroupPrefixJson: [],
            APICalled: false,
            loading: { ...SCROLL_SECTION_LOADING },
            SelectedFiterJson: this.props.binddashboarddata,
            SelectedFiterTag: JSON.parse(props.binddashboarddata[0]["filterJson"]),
            SelectedFilterName: this.props.binddashboarddata[0].filterName,
            RoleType: _roletype,
            RoleName: _rolename,
            prescribe_status: false
        };
        this.isScrollLoading = {};
        this.canLoadMore = {};
        this.hasReachedEnd = {};
        this.handleCheckbox = this.handleCheckbox.bind(this);
        this.FilterTextKeyUp = this.FilterTextKeyUp.bind(this);
        //let s1 = this.state.SelectedFiterTag;
        //debugger;
    }

    isAnySectionLoading() {
        return Object.values(this.isScrollLoading).some(Boolean);
    }

    setSectionLoading(section, isLoading) {
        if (!section) return;
        this.setState(prev => ({
            loading: { ...prev.loading, [section]: isLoading }
        }));
    }

    clearSectionLoading(section) {
        if (section) {
            this.isScrollLoading[section] = false;
            this.setSectionLoading(section, false);
            return;
        }
        this.isScrollLoading = {};
        this.setState({ loading: { ...SCROLL_SECTION_LOADING } });
    }

    finishScrollLoading(section, hasMoreData) {
        this.clearSectionLoading(section);
        if (hasMoreData) {
            this.canLoadMore[section] = true;
        } else {
            this.canLoadMore[section] = false;
        }
    }

    fetchPrescriberInfo() {
        try {
            let whid = this.state.userdata.wholesaler_Id.toString();
            userService.WhPrescribeInfo(whid).then(
                apidata => {
                    try {
                        if (apidata.length > 0) {
                            this.setState({ prescribe_status: apidata[0]._IsPrescribeData });
                        }
                    }
                    catch (error) {
                    }
                }
            );
        }
        catch (error) {
        }
    }

    mergeLazyLoadItems(targetArr, apidata) {
        const items = Array.isArray(apidata) ? apidata : [];
        const newArr = targetArr || [];
        let addedCount = 0;
        items.forEach((e1) => {
            if (newArr.filter(function (e) { return e.text == e1.text }).length < 1) {
                newArr.push(e1);
                addedCount++;
            }
        });
        return { newArr, addedCount };
    }

    getLazyLoadListState(stype) {
        const stateMap = {
            'CITY': 'CityJson',
            'ZIP': 'ZipJson',
            'DRUG': 'DrugJson',
            'PHARMACYNAME': 'PharmacyJson',
            'PRESCRIBERNAME': 'PrescriberJson',
            'GROUPNUMBER': 'GroupNameJson',
            'DISTRIBUTOR': 'DistributorJson',
            'WHOLESALER': 'WholesalerJson'
        };
        const stateKey = stateMap[stype];
        return stateKey ? { stateKey, list: this.state[stateKey] } : null;
    }

    HandleCancelSaveFilter() {
        $('.save-filter-section').slideToggle();
        $('#errormsg').text("");
    }
    saveFilter() {
        $('.save-filter-section').slideToggle();
    }
    UpdateSaveFilter = e => {
        try {
            let CreatedTagJson = this.SelectedTagJsonBuilding();
            if ($('#FilterNameText').val() != null && $('#FilterNameText').val() != '' && $('#FilterNameText').val() != undefined) {
                if (userService.ValidateSpace($('#FilterNameText').val())) {
                    $('#FilterNameText').addClass('errorIcon');
                    $('#errormsg').text("Space not acceptable");

                } else {
                    if (CreatedTagJson != null && CreatedTagJson != undefined && CreatedTagJson != undefined && CreatedTagJson != "" && CreatedTagJson != "null") {
                        this.SaveUpdateFilterDetail(this.state.SelectedFilterName, CreatedTagJson, this.state.userdata["dList"][0].dashboardId, this.props.binddashid);
                    }
                    else {
                        $('#errormsg').text("Please select any of item");
                    }
                }
            } else {
                $('#FilterNameText').css('border-color', 'red');
                $('#errormsg').text("Please enter filter name");
            }
        }
        catch (error) {
            alert(error);
        }
    }

    SaveUpdateFilterDetail(FilterName, FilterJson, DashboardId, FilterId) {
        $('.btn.first-one').prop('disabled', true);
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ FilterName, FilterJson, DashboardId, FilterId })
            };
            return fetch(`/api/Filter/UpdateUserAdFilter`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        $('.save-filter-section').slideToggle();
                        $('.btn.first-one').prop('disabled', false);
                        this.props.closePopup();
                    }
                    catch (error) {
                        $('.btn.first-one').prop('disabled', false);
                    }
                });
        }
        catch (error) {
            $('.btn.first-one').prop('disabled', false);
        }
    }

    GetFilterRawDataDetail(username, usertype, whname, distributor_UserId) {
        try {
            debugger;
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, usertype, whname, distributor_UserId })
            };
            return fetch(`/api/Filter/OnLoadFilterData`, requestOptions)
                //return fetch(`/api/Filter/GeoFilterData`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {

                    try {
                        this.setState({
                            CityJson: apidata[0]["fcity"],
                            StateJson: apidata[0]["fstate"],
                            ZipJson: apidata[0]["fzip"],
                            DrugJson: apidata[0]["fdrug"],
                            PharmacyJson: apidata[0]["fpharmacy"],
                            PrescriberJson: apidata[0]["fprescriber"],
                            GroupNameJson: apidata[0]["groupNumber"],
                            DistributorJson: apidata[0]["distributor"],
                            WholesalerJson: apidata[0]["wholesaler"],
                            PbmJson: apidata[0]["fpbm"],
                            BinJson: apidata[0]["bin"],
                            GroupPrefixJson: apidata[0]["gnPrefix"]
                        });
                        //this.MakeListDistinct();
                    }
                    catch (error) {
                    }
                });
        }
        catch (error) {

        }
    }

    handleResponse(response) {
        return response.text().then(text => {
            try {
                const data = text ? JSON.parse(text) : [];
                return Array.isArray(data) ? data : [];
            }
            catch (error) {
                return [];
            }
        });
    }

    GetNewItem_Search_LazyLoading(stext, stype, roletype, rolename, whname, itemlist, FilterType, TagId) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'requestHeader': itemlist },
                body: JSON.stringify({ stext, stype, roletype, rolename, whname })
            };
            return fetch(`/api/Filter/LazyLoadingData`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        const listState = this.getLazyLoadListState(stype);
                        let addedCount = 0;
                        if (listState) {
                            const merged = this.mergeLazyLoadItems(listState.list, apidata);
                            addedCount = merged.addedCount;
                            this.setState({ [listState.stateKey]: merged.newArr });
                        }
                        if (FilterType != 'scroll') {
                            stext = stext.toLowerCase();
                            let filtered = $('#' + TagId).find('.scroll-section .checkbox-section .same-checkbox');
                            $(filtered).filter(function () {
                                $(this).toggle($(this).text().toLowerCase().indexOf(stext) > -1)
                            });
                        }
                        if (FilterType === 'scroll') {
                            if (addedCount === 0) {
                                this.hasReachedEnd[stype] = true;
                            }
                            this.finishScrollLoading(stype, addedCount > 0);
                        }
                    }
                    catch (error) {
                        if (FilterType === 'scroll') {
                            this.hasReachedEnd[stype] = true;
                            this.finishScrollLoading(stype, false);
                        }
                    }
                })
                .catch(() => {
                    if (FilterType === 'scroll') {
                        this.canLoadMore[stype] = true;
                        this.finishScrollLoading(stype, true);
                    }
                });
        }
        catch (error) {
        }
    }

    handleFilter_static(e) {
        try {
            let val = e.target.value.toLowerCase();
            let TargetId = $(e.target).attr('id').replace('1', '0');
            let filtered = $('#' + TargetId).find('.scroll-section .checkbox-section .same-checkbox');
            $(filtered).filter(function () {
                $(this).toggle($(this).text().toLowerCase().indexOf(val) > -1)
            });
        }
        catch (error) { }
    }
    handleFilter = e => {
        try {
            let TargetName = $(e.target).attr('name');
            let val = e.target.value.toLowerCase();
            let TargetId = $(e.target).attr('id').replace('1', '0');
            if (TargetName != 'PhStateInput' && TargetName != 'PrStateInput' && TargetName != 'PBMInput') {
                if ($(e.target).val().length >= 3) {
                    let stext = $(e.target).val();
                    let TargetJson = this.SelectedSearchTypeItemList($(e.target).attr('scroll-id'));
                    this.GetNewItem_Search_LazyLoading($(e.target).val(), $(e.target).attr('scroll-id'), this.state.RoleType, this.state.RoleName, this.state.userdata.wholesaler, JSON.stringify(JSON.parse(TargetJson)["dataset"]), 'TypeSearch', TargetId);
                    this.clearSectionLoading($(e.target).attr('scroll-id'));
                }
                else {
                    //debugger;
                    let filtered = $('#' + TargetId).find('.scroll-section .checkbox-section .same-checkbox');
                    if ($(e.target).val() == '' || $(e.target).val() == null || $(e.target).val() == undefined) {
                        let filtered = $('#' + TargetId).find('.scroll-section .checkbox-section .same-checkbox');
                        $(filtered).filter(function () {
                            if ($(this).css('display', 'none')) {
                                $(this).toggle();
                            }
                        });
                        this.clearSectionLoading($(e.target).attr('scroll-id'));
                    }
                }
            }
        }
        catch (error) {

        }
    }

    SelectedSearchTypeItemList(inputname) {
        let CreatedJson = '';
        let CreatedTagList = $('div[datascroll="' + inputname + '"]').find('label');
        if (CreatedTagList.length > 0) {
            try {
                let JsonData = '';
                let UnodeValue = '';
                let textval = '';
                for (var it = 0; it < CreatedTagList.length; it++) {
                    textval = '';
                    textval = CreatedTagList[it].innerText;
                    if (UnodeValue == '') {
                        UnodeValue = "\"" + textval.trim() + "\"";
                    }
                    else {
                        if (UnodeValue.toLowerCase().indexOf(textval.trim().toLowerCase()) == -1) {
                            UnodeValue = UnodeValue + ',' + "\"" + textval.trim() + "\"";
                        }
                    }
                }
                JsonData = "\"" + "ItemList" + "\"" + ': [' + UnodeValue + ']';
                JsonData = '{' + "\"" + "dataset" + "\"" + ': {' + JsonData + '}}';
                CreatedJson = JsonData;
            }
            catch (error) {
            }
            return CreatedJson;
        }
    }
    handleScroll = e => {
        let section;
        try {
            const element = e.target;
            section = $(e.target).attr('datascroll');
            const isAtBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 1;

            if (this.hasReachedEnd[section]) return;

            if (!isAtBottom) {
                this.canLoadMore[section] = true;
                return;
            }

            if (this.isAnySectionLoading()) return;
            if (this.isScrollLoading[section] || this.canLoadMore[section] === false) return;

            this.canLoadMore[section] = false;
            this.isScrollLoading[section] = true;
            this.setSectionLoading(section, true);

            const itemListJson = this.SelectedSearchTypeItemList(section);
            if (!itemListJson) {
                this.clearSectionLoading(section);
                return;
            }
            const itemlist = JSON.stringify(JSON.parse(itemListJson)["dataset"]);
            this.GetNewItem_Search_LazyLoading('', section, this.state.RoleType, this.state.RoleName, this.state.userdata.wholesaler, itemlist, 'scroll', '');
        }
        catch (error) {
            if (section) {
                this.clearSectionLoading(section);
            }
        }
    }

    handleCheckbox(e) {
        var mainDiv, close, spanElement;
        var currentCheckbox = $(e.target).attr('name');
        var currentCheckboxvalue = $(e.target).attr('value');
        if (e.target.checked) {
            try {
                mainDiv = document.createElement("DIV");
                mainDiv.setAttribute("class", "selected-filter-name");
                close = document.createElement("span");
                close.setAttribute("class", "close");
                close.setAttribute("data-id", currentCheckbox + '_' + currentCheckboxvalue);
                mainDiv.append(close);
                spanElement = document.createElement("span");
                spanElement.setAttribute("class", "city-name");
                spanElement.setAttribute("tagid", currentCheckbox + '_' + currentCheckboxvalue);
                spanElement.setAttribute("nodename", currentCheckbox);
                spanElement.setAttribute("nodevalue", currentCheckboxvalue);
                let tagspantext = currentCheckboxvalue;
                try {
                    if (tagspantext.length >= 10) {
                        tagspantext = tagspantext.substring(0, 7) + '...';
                    }
                }
                catch (error) { }
                spanElement.innerHTML = tagspantext;
                mainDiv.append(spanElement);
                $(".selectFilter").append(mainDiv);
                $('#errormsg').text("");
                // return false;
            }
            catch (error) { }
        } else {
            try {
                var currentUnCheckbox = $(e.target).attr('name');
                var currentUnCheckboxvalue = $(e.target).attr('value');
                $(e.target).prop("checked", false);
                $(e.target).attr("checked", false);
                //$('input[name="' + currentUnCheckbox + '"][value="' + currentUnCheckboxvalue + '"]').prop("checked", false);
                let TagID = currentUnCheckbox + '_' + currentUnCheckboxvalue;
                $('span[tagid="' + TagID + '"]').parent().remove();
                if ($('.selectFilter').find('span').length <= 0) {
                    $('#errormsg').text("Please select any of item");
                }
                e.target.removeAttribute("unchecked");


                //return false;
            }
            catch (error) { }
        }
        try {
            close.onclick = function (e) {
                var currentclosetag = $(e.target).attr('data-id').split('_')[0];
                var currentclosecheckbox = $(e.target).attr('data-id').split('_')[1];
                try {
                    if (currentclosetag === 'Group Prefix') {
                        let filtered = $('#PhGPrefixInput0').find('.scroll-section .checkbox-section .same-checkbox');
                        $(filtered).filter(function () {
                            $(this).find('input:checkbox[name="' + currentclosetag + '"][value="' + currentclosecheckbox + '"]').prop("checked", false);
                        });
                    }
                    else {
                        let filtered = $('#' + currentclosetag + 'Input0').find('.scroll-section .checkbox-section .same-checkbox');
                        $(filtered).filter(function () {
                            $(this).find('input:checkbox[name="' + currentclosetag + '"][value="' + currentclosecheckbox + '"]').prop("checked", false);
                        });
                    }
                    try {
                        let utagid = currentclosetag + '_' + currentclosecheckbox;
                        $('span[tagid="' + utagid + '"]').parent().remove();
                        if ($('.selectFilter').find('span').length <= 0) {
                            $('#errormsg').text("Please select any of item");
                        }
                    } catch (error) {

                    }
                }
                catch (error) {
                }
            }
        }
        catch (error) {
            try {
                var currentclosetag = $(e.target).attr('data-id').split('_')[0];
                var currentclosecheckbox = $(e.target).attr('data-id').split('_')[1];
                try {
                    if (currentclosetag === 'Group Prefix') {
                        let filtered = $('#PhGPrefixInput0').find('.scroll-section .checkbox-section .same-checkbox');
                        $(filtered).filter(function () {
                            $(this).find('input:checkbox[name="' + currentclosetag + '"][value="' + currentclosecheckbox + '"]').prop("checked", false);
                        });
                    }
                    else {
                        let filtered = $('#' + currentclosetag + 'Input0').find('.scroll-section .checkbox-section .same-checkbox');
                        $(filtered).filter(function () {
                            $(this).find('input:checkbox[name="' + currentclosetag + '"][value="' + currentclosecheckbox + '"]').prop("checked", false);
                        });
                    }
                    try {
                        let utagid = currentclosetag + '_' + currentclosecheckbox;
                        $('span[tagid^="' + utagid + '"]').parent().remove();
                        if ($('.selectFilter').find('span').length <= 0) {
                            $('#errormsg').text("Please select any of item");
                        }
                    } catch (error) {
                    }
                }
                catch (error) {
                }
            }
            catch (error) {
            }
        }
    }

    componentDidMount() {
        this.fetchPrescriberInfo();
        if (this.state.userdata.userrole == "Distributor" && this.state.userdata.wholesaler == "Avenel") {
            this.GetFilterRawDataDetail(this.state.RoleName, this.state.RoleType, this.state.userdata.wholesaler_Id, this.state.userdata.distributor_UserId);
        }
        else if (this.state.userdata.userrole == "Distributor" && this.state.userdata.wholesaler != "Avenel") {
            this.GetFilterRawDataDetail(this.state.RoleName, this.state.RoleType, this.state.userdata.wholesaler_Id, this.state.userdata.distributor_UserId);
        }
        else {
            this.GetFilterRawDataDetail(this.state.RoleName, this.state.RoleType, this.state.userdata.wholesaler_Id, -1);
        }
        //this.GetFilterRawDataDetail(this.state.RoleName, this.state.RoleType, this.state.userdata.wholesaler_Id);
        this.MakeSelectedItemChecked();
        //document.addEventListener('scroll', this.trackScrolling);
        setTimeout(() => {
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 5);
    }

    HandleApplyFilter = e => {
        try {
            if ($('.selectFilter').find('span').length <= 0) {
                $('#errormsg').text("Please select any of item");
                return false;
            }
            else {
                localStorage.setItem('Advance_Filter', JSON.stringify(JSON.parse(this.SelectedTagJsonBuilding())["dataset"]));
                window.location.href = window.location.origin + '/dashboard'
            }
        } catch (error) {
        }
    }

    HandleResetFilter = e => {
        try {
            $('input[type=checkbox]').prop("checked", false);
            $(".selectFilter").html('');

            $(".searchFilter").each(function () {
                if ($(this).val() != '') {

                    let TargetId = $(this).attr('id').replace('1', '0');
                    let filtered = $('#' + TargetId).find('.scroll-section .checkbox-section .same-checkbox');
                    $(filtered).filter(function () {
                        if ($(this).css('display', 'none')) {
                            $(this).toggle();
                        }
                    });
                    $(this).val("");
                }
            });

        } catch (error) {
        }
    }
    SelectedTagJsonBuilding() {
        var CreatedJson = '';
        try {
            let CreatedTagList = $('.selectFilter').find('.city-name');
            if (CreatedTagList.length > 0) {
                var nodes = [], values = [];
                for (var i = 0; i < CreatedTagList.length; i++) {
                    nodes.push($(CreatedTagList[i]).attr('nodename'));
                }
                var uniquenodes = nodes.filter((v, i, a) => a.indexOf(v) === i);
                try {
                    let JsonData = '';
                    for (var i = 0; i < uniquenodes.length; i++) {
                        let UnodeName = uniquenodes[i];
                        let UnodeValue = '';
                        for (var j = 0; j < CreatedTagList.length; j++) {
                            if ($(CreatedTagList[j]).attr('nodename') == UnodeName) {
                                if (UnodeValue == '') {
                                    UnodeValue = "\"" + $(CreatedTagList[j]).attr('nodevalue') + "\"";
                                }
                                else {
                                    UnodeValue = UnodeValue + ',' + "\"" + $(CreatedTagList[j]).attr('nodevalue') + "\"";
                                }
                            }
                        }
                        if (JsonData == '') {
                            JsonData = "\"" + UnodeName + "\"" + ': [' + UnodeValue + ']';
                        }
                        else {
                            JsonData = JsonData + "," + "\"" + UnodeName + "\"" + ': [' + UnodeValue + ']';
                        }
                    }
                    JsonData = '{' + "\"" + "dataset" + "\"" + ': {' + JsonData + '}}';
                    CreatedJson = JsonData;
                }
                catch (error) {

                }
            }

        } catch (error) {
        }
        return CreatedJson;
    }
    FilterTextKeyUp(e) {
        this.setState({ SelectedFilterName: e.target.value });
        $('#FilterNameText').css('border-color', '#dde5ed');
        $('#errormsg').text("");
        $('#FilterNameText').removeClass('errorIcon');
    }
    MakeSelectedItemChecked() {
        try {
            let s11 = $('input[type=checkbox][name="PBM"]').length;
            if (s11 > 0) {
                Object.keys(this.state.SelectedFiterTag["dataset"]).map((key, index) => {
                    this.state.SelectedFiterTag["dataset"][key].map((e1, i1) => {
                        if ($('#BindDynamicTags span[nodename="' + key + '"][nodevalue="' + e1 + '"]').length > 0) {
                            $('input[type=checkbox][name="' + key + '"][value="' + e1 + '"]').prop("checked", true);
                        }
                    });
                });
            }
        }
        catch (error) {
        }
    }
    componentDidUpdate() {
        this.MakeSelectedItemChecked();
    }
    resetColor = e => {
        $('.btn').addClass('changeColor');
    }
    changeClass = e => {
        $('.btn').removeClass('changeColor');
    }

    render() {
        let len = 0;
        try {
            len = this.state.CityJson.length + this.state.StateJson.length + this.state.ZipJson.length + this.state.PbmJson.length;
        }
        catch (error) {
            len = 0;
        }
        this.MakeSelectedItemChecked();

        if (len > 0) {

            const { SelectedFilterName } = this.state;
            return (
                <div className='popup mfp-zoom-in CreateNewFilter'>
                    <div className='popup_inner'>
                        <h1>{this.props.text}<button onClick={this.props.closePopup}>X</button></h1>
                        <div className="filter-Content TransitionsPopup">
                            <div className="filter-scroll theme-checkbox">
                                {/*---------New Filter Row--*/}
                                <div className="repeat-section" id="PhCityInput0">
                                    <h3>Pharmacy City</h3>
                                    <div className="searchSection">
                                        <img className="SearchIcon" src={Search_Icon} alt="" />
                                        <form autoComplete="off">
                                            <div className="autocomplete">
                                                <input id="PhCityInput1" type="text" name="PhCityInput" data-id="dynamic" scroll-id="CITY" placeholder="Search" onKeyUp={this.handleFilter} className="form-control searchFilter" />
                                            </div>
                                        </form>
                                    </div>
                                    <div className="scroll-section" datascroll="CITY" onScroll={this.handleScroll}>
                                        {

                                            this.state.CityJson != null ? this.state.CityJson[0] ?
                                                <div className="checkbox-section" key={"CityList"}>
                                                    {this.state.CityJson.map((e1, i1) => {
                                                        return (
                                                            <div className="same-checkbox" key={'PhCity' + i1}> <label><input type="checkbox" id={'PhCity' + i1} onChange={this.handleCheckbox} name="PhCity" value={e1.text} /><span className="checkmark"></span><label for={'PhCity' + i1}>{e1.text}</label></label></div>
                                                        )
                                                    })}
                                                    {this.state.loading.CITY ? <div className="theme-loader resetLoader scroll-loader"></div> : null}
                                                </div> : null : null
                                        }

                                    </div>
                                </div>
                                <div className="repeat-section gap" id="PhStateInput0">
                                    <h3>Pharmacy State</h3>
                                    <div className="searchSection">
                                        <img className="SearchIcon" src={Search_Icon} alt="" />
                                        <form autoComplete="off">
                                            <div className="autocomplete">
                                                <input id="PhStateInput1" type="text" name="PhStateInput" placeholder="Search" onKeyUp={this.handleFilter_static} className="form-control searchFilter" />
                                            </div>
                                        </form>
                                    </div>
                                    <div className="scroll-section">
                                        {

                                            this.state.StateJson != null ? this.state.StateJson[0] ?
                                                <div className="checkbox-section" key={"PhStateList"}>
                                                    {this.state.StateJson.map((e1, i1) => {
                                                        return (
                                                            <div className="same-checkbox" key={'PhState' + i1}> <label><input type="checkbox" id={'PhState' + i1} onChange={this.handleCheckbox} name="PhState" value={e1.text} /><span className="checkmark"></span><label for={'PhState' + i1}>{e1.text}</label></label></div>
                                                        )
                                                    })}

                                                </div> : null : null
                                        }
                                    </div>
                                </div>
                                <div className="repeat-section" id="PhZipInput0">
                                    <h3>Pharmacy Zip</h3>
                                    <div className="searchSection">
                                        <img className="SearchIcon" src={Search_Icon} alt="" />
                                        <form autoComplete="off">
                                            <div className="autocomplete">
                                                <input id="PhZipInput1" type="text" name="PhZipInput" placeholder="Search" scroll-id="ZIP" onKeyUp={this.handleFilter} className="form-control searchFilter" />
                                            </div>
                                        </form>
                                    </div>
                                    <div className="scroll-section" datascroll="ZIP" onScroll={this.handleScroll}>
                                        {

                                            this.state.ZipJson != null ? this.state.ZipJson[0] ?

                                                <div className="checkbox-section" key={"PhZipList"}>
                                                    {this.state.ZipJson.map((e1, i1) => {
                                                        return (
                                                            <div className="same-checkbox" key={'PhZip' + i1}> <label><input id={'PhZip' + i1} type="checkbox" onChange={this.handleCheckbox} name="PhZip" value={e1.text} /><span className="checkmark"></span><label for={'PhZip' + i1}>{e1.text}</label></label></div>
                                                        )
                                                    })}
                                                    {this.state.loading.ZIP ? <div className="theme-loader resetLoader scroll-loader"></div> : null}

                                                </div> : null : null
                                        }
                                    </div>
                                </div>

                                {/*---------New Filter Row--
                                <div className="repeat-section" id="PrCityInput0">
                                    <h3>Prescriber City</h3>
                                    <div className="searchSection">
                                        <img className="SearchIcon" src={Search_Icon} alt="" />
                                        <form autoComplete="off">
                                            <div className="autocomplete">
                                                <input id="PrCityInput1" type="text" name="PrCityInput" placeholder="Search" scroll-id="CITY" onKeyUp={this.handleFilter} className="form-control searchFilter" />
                                            </div>
                                        </form>
                                    </div>
                                    <div className="scroll-section" datascroll="CITY" onScroll={this.handleScroll}>
                                        {

                                            this.state.CityJson != null ? this.state.CityJson[0] ?
                                                <div className="checkbox-section" key={"PrCityList"}>
                                                    {this.state.CityJson.map((e1, i1) => {
                                                        return (
                                                            <div className="same-checkbox" key={'PrCity' + i1}> <label><input id={'PrCity' + i1} type="checkbox" onChange={this.handleCheckbox} name="PrCity" value={e1.text} /><span className="checkmark"></span><label for={'PrCity' + i1}>{e1.text}</label></label></div>
                                                        )

                                                    })}
                                                    {this.state.loading.CITY ? <div className="theme-loader resetLoader scroll-loader"></div> : null}
                                                </div> : null : null

                                        }
                                    </div>
                                </div>
                                <div className="repeat-section gap" id="PrStateInput0">
                                    <h3>Prescriber State</h3>
                                    <div className="searchSection">
                                        <img className="SearchIcon" src={Search_Icon} alt="" />
                                        <form autoComplete="off">
                                            <div className="autocomplete">
                                                <input id="PrStateInput1" type="text" name="PrStateInput" placeholder="Search" onKeyUp={this.handleFilter_static} className="form-control searchFilter" />
                                            </div>
                                        </form>
                                    </div>
                                    <div className="scroll-section">
                                        {

                                            this.state.StateJson != null ? this.state.StateJson[0] ?
                                                <div className="checkbox-section" key={"PrStateList"}>
                                                    {this.state.StateJson.map((e1, i1) => {
                                                        return (
                                                            <div className="same-checkbox" key={'PrState' + i1}> <label><input id={'PrState' + i1} type="checkbox" onChange={this.handleCheckbox} name="PrState" value={e1.text} /><span className="checkmark"></span><label for={'PrState' + i1}>{e1.text}</label></label></div>
                                                        )
                                                    })}
                                                </div> : null : null
                                        }
                                    </div>
                                </div>
                                <div className="repeat-section" id="PrZipInput0">
                                    <h3>Prescriber Zip</h3>
                                    <div className="searchSection">
                                        <img className="SearchIcon" src={Search_Icon} alt="" />
                                        <form autoComplete="off">
                                            <div className="autocomplete">
                                                <input id="PrZipInput1" type="text" name="PrZipInput" placeholder="Search" scroll-id="ZIP" onKeyUp={this.handleFilter} className="form-control searchFilter" />
                                            </div>
                                        </form>
                                    </div>
                                    <div className="scroll-section" datascroll="ZIP" onScroll={this.handleScroll}>
                                        {

                                            this.state.ZipJson != null ? this.state.ZipJson[0] ?
                                                <div className="checkbox-section" key={"PrZipList"}>
                                                    {this.state.ZipJson.map((e1, i1) => {
                                                        return (
                                                            <div className="same-checkbox" key={'PrZip' + i1}> <label><input id={'PrZip' + i1} type="checkbox" onChange={this.handleCheckbox} name="PrZip" value={e1.text} /><span className="checkmark"></span><label for={'PrZip' + i1}>{e1.text}</label></label></div>
                                                        )
                                                    })}
                                                    {this.state.loading.ZIP ? <div className="theme-loader resetLoader scroll-loader"></div> : null}
                                                </div> : null : null
                                        }
                                    </div>
                                </div>
                                */}
                                {/*---------New Filter Row--*/}
                                <div className="repeat-section" id="PBMInput0">
                                    <h3>PCN</h3>
                                    <div className="searchSection">
                                        <img className="SearchIcon" src={Search_Icon} alt="" />
                                        <form autoComplete="off">
                                            <div className="autocomplete">
                                                <input id="PBMInput1" type="text" name="PBMInput" placeholder="Search" onKeyUp={this.handleFilter_static} className="form-control searchFilter" />
                                            </div>
                                        </form>
                                    </div>
                                    <div className="scroll-section pcn_text_caps">
                                        {

                                            this.state.PbmJson != null ? this.state.PbmJson[0] ?
                                                <div className="checkbox-section" key={"PbmlistList"}>
                                                    {this.state.PbmJson.map((e1, i1) => {
                                                        return (
                                                            <div className="same-checkbox" key={'PBM' + i1}> <label><input id={'PBM' + i1} type="checkbox" onChange={this.handleCheckbox} name="PBM" value={e1.text} /><span className="checkmark"></span><label for={'PBM' + i1}>{e1.text}</label></label></div>
                                                        )
                                                    })}
                                                </div> : null : null

                                        }
                                    </div>
                                </div>
                                <div className="repeat-section gap" id="DrugNameInput0">
                                    <h3>Drug Name</h3>
                                    <div className="searchSection">
                                        <img className="SearchIcon" src={Search_Icon} alt="" />
                                        <form autoComplete="off">
                                            <div className="autocomplete">
                                                <input id="DrugNameInput1" type="text" name="DrugNameInput" placeholder="Search" scroll-id="DRUG" onKeyUp={this.handleFilter} className="form-control searchFilter" />
                                            </div>
                                        </form>
                                    </div>
                                    <div className="scroll-section" datascroll="DRUG" onScroll={this.handleScroll}>
                                        {

                                            this.state.DrugJson != null ? this.state.DrugJson[0] ?
                                                <div className="checkbox-section" key={"DrugList"}>
                                                    {this.state.DrugJson.map((e1, i1) => {
                                                        return (
                                                            <div className="same-checkbox" key={'DrugName' + i1}> <label><input id={'DrugName' + i1} type="checkbox" onChange={this.handleCheckbox} name="DrugName" value={e1.text} /><span className="checkmark"></span><label for={'DrugName' + i1}>{e1.text}</label></label></div>
                                                        )
                                                    })}
                                                    {this.state.loading.DRUG ? <div className="theme-loader resetLoader scroll-loader"></div> : null}
                                                </div> : null : null
                                        }
                                    </div>
                                </div>
                                <div className="repeat-section" id="PharmacyNameInput0">
                                    <h3>Pharmacy Name</h3>
                                    <div className="searchSection">
                                        <img className="SearchIcon" src={Search_Icon} alt="" />
                                        <form autoComplete="off">
                                            <div className="autocomplete">
                                                <input id="PharmacyNameInput1" type="text" name="PharmacyNameInput" scroll-id="PHARMACYNAME" placeholder="Search" onKeyUp={this.handleFilter} className="form-control searchFilter" />
                                            </div>
                                        </form>
                                    </div>
                                    <div className="scroll-section" datascroll="PHARMACYNAME" onScroll={this.handleScroll}>
                                        {

                                            this.state.PharmacyJson != null ? this.state.PharmacyJson[0] ?
                                                <div className="checkbox-section" key={"PharmacyNameList"}>
                                                    {this.state.PharmacyJson.map((e1, i1) => {
                                                        return (
                                                            <div className="same-checkbox" key={'PharmacyName' + i1}> <label><input id={'PharmacyName' + i1} type="checkbox" onChange={this.handleCheckbox} name="PharmacyName" value={e1.text} /><span className="checkmark"></span><label for={'PharmacyName' + i1} >{e1.text}</label></label></div>
                                                        )
                                                    })}
                                                    {this.state.loading.PHARMACYNAME ? <div className="theme-loader resetLoader scroll-loader"></div> : null}
                                                </div> : null : null
                                        }
                                    </div>
                                </div>

                                {/*---------New Filter Row--*/}
                                {((this.state.prescribe_status === true && (this.state.userdata.userrole === 'Wholesaler' || this.state.userdata.userrole === 'Distributor')) || (this.state.userdata.userrole === "Admin" || this.state.userdata.userrole === "SubAdmin")) ?
                                    <div className="repeat-section" id="PrescriberInput0">
                                        <h3>Prescriber Name</h3>
                                        <div className="searchSection">
                                            <img className="SearchIcon" src={Search_Icon} alt="" />
                                            <form autoComplete="off">
                                                <div className="autocomplete">
                                                    <input id="PrescriberInput1" type="text" name="PrescriberInput" scroll-id="PRESCRIBERNAME" placeholder="Search" onKeyUp={this.handleFilter} className="form-control searchFilter" />
                                                </div>
                                            </form>
                                        </div>
                                        <div className="scroll-section" datascroll="PRESCRIBERNAME" onScroll={this.handleScroll}>
                                            {

                                                this.state.PrescriberJson != null ? this.state.PrescriberJson[0] ?
                                                    <div className="checkbox-section" key={"PrescriberList"}>
                                                        {this.state.PrescriberJson.map((e1, i1) => {
                                                            return (
                                                                <div className="same-checkbox" key={'Prescriber' + i1}> <label><input id={'Prescriber' + i1} type="checkbox" onChange={this.handleCheckbox} name="Prescriber" value={e1.text} /><span className="checkmark"></span><label for={'Prescriber' + i1}>{e1.text}</label></label></div>
                                                            )
                                                        })}
                                                        {this.state.loading.PRESCRIBERNAME ? <div className="theme-loader resetLoader scroll-loader"></div> : null}
                                                    </div> : null : null

                                            }
                                        </div>
                                    </div> : null
                                }
                                    < div className="repeat-section" id="GroupNumberInput0">
                                    <h3>Group Number</h3>
                                <div className="searchSection">
                                    <img className="SearchIcon" src={Search_Icon} alt="" />
                                    <form autoComplete="off">
                                        <div className="autocomplete">
                                            <input id="GroupNumberInput1" type="text" name="GroupNumberInput" scroll-id="GROUPNUMBER" placeholder="Search" onKeyUp={this.handleFilter} className="form-control searchFilter" />
                                        </div>
                                    </form>
                                </div>
                                <div className="scroll-section" datascroll="GROUPNUMBER" onScroll={this.handleScroll}>
                                    {

                                        this.state.GroupNameJson != null ? this.state.GroupNameJson[0] ?
                                            <div className="checkbox-section" key={"GroupNumberList"}>
                                                {this.state.GroupNameJson.map((e1, i1) => {
                                                    return (
                                                        <div className="same-checkbox" key={'GroupNumber' + i1}> <label><input id={'GroupNumber' + i1} type="checkbox" onChange={this.handleCheckbox} name="GroupNumber" value={e1.text} /><span className="checkmark"></span><label for={'GroupNumber' + i1}>{e1.text}</label></label></div>
                                                    )
                                                })}
                                                {this.state.loading.GROUPNUMBER ? <div className="theme-loader resetLoader scroll-loader"></div> : null}
                                            </div> : null : null
                                    }
                                </div>
                            </div>
                            {
                                this.state.userdata.userrole != "Distributor" && this.state.DistributorJson != null && this.state.DistributorJson.length > 0 ?
                                    <div className="repeat-section" id="DistributorNameInput0">
                                        <h3>Distributor Name</h3>
                                        <div className="searchSection">
                                            <img className="SearchIcon" src={Search_Icon} alt="" />
                                            <form autoComplete="off">
                                                <div className="autocomplete">
                                                    <input id="DistributorNameInput1" type="text" scroll-id="DISTRIBUTOR" name="DistributorNameInput" placeholder="Search" onKeyUp={this.handleFilter} className="form-control searchFilter" />
                                                </div>
                                            </form>
                                        </div>
                                        <div className="scroll-section" datascroll="DISTRIBUTOR" onScroll={this.handleScroll}>
                                            {

                                                this.state.DistributorJson != null ? this.state.DistributorJson[0] ?
                                                    <div className="checkbox-section" key={"DistributorNameList"}>
                                                        {this.state.DistributorJson.map((e1, i1) => {
                                                            return (
                                                                <div className="same-checkbox" key={'DistributorName' + i1}> <label><input id={'DistributorName' + i1} type="checkbox" onChange={this.handleCheckbox} name="DistributorName" value={e1.text} /><span className="checkmark"></span><label for={'DistributorName' + i1}>{e1.text}</label></label></div>
                                                            )
                                                        })}
                                                        {this.state.loading.DISTRIBUTOR ? <div className="theme-loader resetLoader scroll-loader"></div> : null}
                                                    </div> : null : null
                                            }
                                        </div>
                                    </div> : null
                            }
                            {/*---------New Filter Row--*/}
                            {
                                this.state.userdata.userrole == "Admin" || this.state.userdata.userrole == "SubAdmin" ?
                                    <div className="repeat-section" id="WholesalerNameInput0">
                                        <h3>Wholesaler Name</h3>
                                        <div className="searchSection">
                                            <img className="SearchIcon" src={Search_Icon} alt="" />
                                            <form autoComplete="off">
                                                <div className="autocomplete">
                                                    <input id="WholesalerNameInput1" type="text" scroll-id="WHOLESALER" name="WholesalerNameInput" placeholder="Search" onKeyUp={this.handleFilter} className="form-control searchFilter" />
                                                </div>
                                            </form>
                                        </div>
                                        <div className="scroll-section" datascroll="WHOLESALER" onScroll={this.handleScroll}>
                                            {
                                                this.state.WholesalerJson != null ? this.state.WholesalerJson[0] ?
                                                    <div className="checkbox-section" key={"WholesalerList"}>
                                                        {this.state.WholesalerJson.map((e1, i1) => {
                                                            return (
                                                                <div className="same-checkbox" key={'WholesalerName' + i1}> <label><input id={'WholesalerName' + i1} type="checkbox" onChange={this.handleCheckbox} name="WholesalerName" value={e1.text} /><span className="checkmark"></span><label for={'WholesalerName' + i1}>{e1.text}</label></label></div>
                                                            )
                                                        })}
                                                        {this.state.loading.WHOLESALER ? <div className="theme-loader resetLoader scroll-loader"></div> : null}
                                                    </div> : null : null
                                            }
                                        </div>
                                    </div> : null
                            }
                            <div className={this.state.userdata.userrole == "Admin" || this.state.userdata.userrole == "SubAdmin" ? "repeat-section gap" : "repeat-section"} id="PhBinInput0">
                                <h3>BIN</h3>
                                <div className="searchSection">
                                    <img className="SearchIcon" src={Search_Icon} alt="" />
                                    <form autoComplete="off">
                                        <div className="autocomplete">
                                            <input id="PhBinInput1" type="text" name="PhBinInput" placeholder="Search" onKeyUp={this.handleFilter_static} className="form-control searchFilter" />
                                        </div>
                                    </form>
                                </div>
                                <div className="scroll-section pcn_text_caps">
                                    {

                                        this.state.BinJson != null ? this.state.BinJson[0] ?
                                            <div className="checkbox-section" key={"BinList"}>
                                                {this.state.BinJson.map((e1, i1) => {
                                                    return (
                                                        <div className="same-checkbox" key={'PhBin' + i1}> <label><input id={'PhBin' + i1} type="checkbox" onChange={this.handleCheckbox} name="PhBin" value={e1.text} /><span className="checkmark"></span><label for={'PhBin' + i1}>{e1.text}</label></label></div>
                                                    )
                                                })}
                                            </div> : null : null

                                    }
                                </div>
                            </div>
                            {
                                this.state.userdata.userrole === "Admin" ?
                                    <div className="repeat-section" id="PhGPrefixInput0">
                                        <h3>Group Prefix</h3>
                                        <div className="searchSection">
                                            <img className="SearchIcon" src={Search_Icon} alt="" />
                                            <form autoComplete="off">
                                                <div className="autocomplete">
                                                    <input id="PhGPrefixInput1" type="text" name="PhGPrefixInput" placeholder="Search" onKeyUp={this.handleFilter_static} className="form-control searchFilter" />
                                                </div>
                                            </form>
                                        </div>
                                        <div className="scroll-section pcn_text_caps">
                                            {

                                                this.state.GroupPrefixJson != null ? this.state.GroupPrefixJson[0] ?
                                                    <div className="checkbox-section" key={"GPrefixJsonList"}>
                                                        {this.state.GroupPrefixJson.map((e1, i1) => {
                                                            return (
                                                                <div className="same-checkbox" key={'PhGPrefix' + i1}> <label><input type="checkbox" id={'PhGPrefix' + i1} onChange={this.handleCheckbox} name="Group Prefix" value={e1.text} /><span className="checkmark"></span><label for={'PhGPrefix' + i1}>{e1.text}</label></label></div>
                                                            )
                                                        })}
                                                    </div> : null : null

                                            }
                                        </div>
                                    </div> : null
                            }
                        </div>
                        <div className="selected-filters">
                            <label>Selected Filters</label>
                            {
                                this.state.SelectedFiterTag != null ?
                                    <div className="selectFilter" id="BindDynamicTags">
                                        {
                                            Object.keys(this.state.SelectedFiterTag["dataset"]).map((key, index) => {

                                                return (this.state.SelectedFiterTag["dataset"][key].map((e1, i1) => {
                                                    try {

                                                        let tagspantext = e1;
                                                        let attribute = key + "_" + e1;
                                                        try {
                                                            if (tagspantext.length >= 10) {
                                                                tagspantext = tagspantext.substring(0, 7) + '...';
                                                            }
                                                        }
                                                        catch (error) { }
                                                        return (
                                                            <div className="selected-filter-name" key={key + "_" + e1}><span className="close" onClick={this.handleCheckbox} data-id={attribute}></span><span className="city-name" tagid={attribute} nodename={key} nodevalue={e1}>{tagspantext}</span></div>
                                                        )
                                                    }
                                                    catch (error) {
                                                    }
                                                }))
                                            })
                                        }
                                    </div>
                                    : <div className="selectFilter" id="BindDynamicTags"></div>
                            }

                        </div>
                        <div className="save-filter-section">
                            <h3>Update Filter</h3>
                            <h4>Name</h4>
                            <input type="text" id="FilterNameText" value={SelectedFilterName} className="form-control" placeholder="Filter set 1" name="SelectedFilterName" onChange={this.FilterTextKeyUp} />
                            <div className="btn-section">
                                <button className="btn first-one btn-theme-color" onClick={this.UpdateSaveFilter}>Update</button>
                                <button className="btn save btn-theme-color" onClick={this.HandleCancelSaveFilter}>Cancel</button>
                            </div>
                            <div className="arrow-down">&nbsp;</div>
                        </div>

                    </div>
                    <div className="btn-section">
                        <button className="btn apply-filter btn-theme-color" onClick={this.HandleApplyFilter}>Apply Filter</button>
                        <button onMouseOut={this.resetColor} onMouseOver={this.changeClass} className="btn reset btn-theme-color" onClick={this.HandleResetFilter}>Reset</button>
                        <button className="btn save btn-theme-color" onClick={this.saveFilter}>Update Filter</button>
                        <div class="help-block alert-danger" id="errormsg"></div>
                    </div>

                </div>




                </div >
            );
        }
        else {
            return (
                <div className='popup mfp-zoom-in CreateNewFilter'>
                    <div className='popup_inner'>
                        <h1>{this.props.text}<button onClick={this.props.closePopup}>X</button></h1>
                        <div className="WhCommission">
                            <div className="theme-loader"></div>
                            <div className="filter-Content TransitionsPopup wait">
                                <h3>Please wait...</h3>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

export default EditFilter;